import React, {
  useContext,
  useEffect,
  useRef,
  useCallback,
  useState,
  useMemo,
} from "react";
import MaterialTable, { MTableBody } from "@material-table/core";
import ListadoContext from "../context/ListadoContext";
import PantallaContext from "../../context/PantallaContext";
import { agregarAcciones } from "../../helper/funciones";

import { Paper } from "@mui/material";

import {
  calcularOpcionesPageSize,
  updateSelectedArray,
  searchData,
} from "./ListadoFunciones";
// import Carrusel from "./Carrusel";

import { Card, CardBody } from "reactstrap";
import HeaderConf from "../../components/HeaderConf";

import tableIcons from "./tableIcons";
import Filtros from "./Filtros";
import Botonera from "../Botonera";

import { TablePagination } from "@mui/material";
import { Checkbox as MuiCheckbox } from "@mui/material";

import SwitchColumnas from "./SwitchColumnas";
import MemoizedOrixiaRow from "./MemoizedOrixaRow";
import Mapa from "./Mapa";
import OrixiaSpinner from "../../components/OrixiaSpinner";

import { useListadoStateStore } from "../context/ListadoStateContext";

import "./listado.scss";

export const Listado = (props) => {
  const datosStore = useListadoStateStore((state) => state.datos);
  const setRegistrosPorPagina = useListadoStateStore(
    (state) => state.setRegistrosPorPagina
  );
  const setDatosSeleccionados = useListadoStateStore(
    (state) => state.setDatosSeleccionados
  );
  const setDatosStore = useListadoStateStore((state) => state.setDatos);
  const { columnas, tots } = props;

  const {
    opcionesListado,
    listadoBotones,
    Dispatch,
    //loading_pantalla:loading,
    loading,
    cabeceras,
    datos,
    subirDatosSeleccionados,
    cambiarPagina,
    handleCancelar,
  } = useContext(ListadoContext);

  const calcPagesize = useCallback(() => {
    let size = 10;

    if (opcionesListado.cantdd_registros) {
      size =
        Number(opcionesListado.cantdd_registros) === 0
          ? datos.length
          : Number(opcionesListado.cantdd_registros);
    }

    if (datos.length === 0) {
      size = 0;
    }
    if (datos.length < size) {
      size = datos.length;
    }
    if (
      opcionesListado.cantdd_registros_max &&
      size > opcionesListado.cantdd_registros_max
    ) {
      size = opcionesListado.cantdd_registros_max;
    }
    if (
      opcionesListado.paginar_backend === "s" &&
      opcionesListado.paginacion_backend
    ) {
      return opcionesListado.paginacion_backend.perPage;
    }
    return Number(size);
  }, [
    datos.length,
    opcionesListado.cantdd_registros,
    opcionesListado.cantdd_registros_max,
    opcionesListado.paginacion_backend,
    opcionesListado.paginar_backend,
  ]);

  const { opciones_de_pantalla } = useContext(PantallaContext);

  const [selected, setSelected] = useState();
  const [pageOptions, setPageOptions] = useState([]);
  const [mapa, setMapa] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(
    Number(opcionesListado.cantdd_registros) ?? 0,
  );

  const renderSummaryRow =
    cabeceras.filter((c) => c.totalizar === "s").length > 0;

  const listadoBotonesInferiores = listadoBotones.filter(
    (b) => b.listado_boton_inferior === "s",
  );

  const padding = "2px 6px";

  const pageSize = useMemo(() => calcPagesize(), [calcPagesize]);
  const tableRef = useRef(null);

  useEffect(() => {
    setRegistrosPorPagina(pageSize);

    if (!tableRef.current?.dataManager) {
      return;
    }

    tableRef.current.dataManager.changePageSize(pageSize);
    setCurrentPageSize(pageSize);
    setPageOptions(() =>
      calcularOpcionesPageSize(pageSize, opcionesListado.cantdd_registros_max),
    );
    tableRef.current.dataManager.searchData = () =>
      searchData(tableRef.current.dataManager);
  }, [columnas, opcionesListado.cantdd_registros_max, pageSize, setRegistrosPorPagina]);

  useEffect(() => {
    if (opcionesListado.paginar_backend === "s" && opcionesListado.paginacion_backend) {
      setCurrentPage(Math.max(Number(opcionesListado.paginacion_backend.currentPage) - 1, 0));
      return;
    }

    if (tableRef.current?.dataManager?.currentPage !== undefined) {
      setCurrentPage(tableRef.current.dataManager.currentPage);
    }
  }, [datos, opcionesListado.paginar_backend, opcionesListado.paginacion_backend]);

  const gridColumn = {
    gridColumn: opcionesListado.grid_span
      ? opcionesListado.grid_span
      : "1 / -1",
  };

  const mensajeSinDatos = (
    <p style={{ paddingTop: "15px" }}>
      {opcionesListado.consultaEjecutada === "n"
        ? ""
        : opcionesListado.mensaje_sin_datos || "No se encontraron datos"}
    </p>
  );

  agregarAcciones(opciones_de_pantalla, opcionesListado);

  const mapaCab = columnas?.filter((c) => c.componente === "mapa").pop();

  let labelDisplayedRows = "{from}-{to} de {count}";

  if (opcionesListado.paginacion_backend) {
    const { currentPage, total, perPage, exactTotal } =
      opcionesListado.paginacion_backend;
    const desde = perPage * (currentPage - 1) + 1;
    const hasta = Math.min(currentPage * perPage, total);

    labelDisplayedRows = exactTotal
      ? `${desde}-${hasta} de ${total}`
      : `${desde}-${hasta} de aprox. ${total}`;
  }

  const dispatchSeleccion = (row) => {
    if (!Array.isArray(row)) {
      row = [row];
    }
    const fixdata = (dataToFix) => {
      try {
        return dataToFix.map((d, i) => {
          d.tableData = { checked: false, index: i };
          for (const r of row) {
            if (r.tableData.index === i) {
              d.tableData = r.tableData;
              for (const cab of cabeceras) {
                if (cab.clave_envio && cab.clave_envio !== "")
                  d[cab.clave_envio] = d[cab.id_a];
              }
            }
          }
          return d;
        });
      } catch (err) {
        console.log(err, dataToFix);
      }
    };
    const fixRows = (rowsToFix) => {
      if (!Array.isArray(rowsToFix)) {
        rowsToFix = [rowsToFix];
      }
      return rowsToFix.map((d, i) => {
        for (const r of rowsToFix) {
          if (r.tableData.index === i) {
            for (const cab of cabeceras) {
              if (cab.clave_envio && cab.clave_envio !== "")
                d[cab.clave_envio] = d[cab.id_a];
            }
          }
        }
        return d;
      });
    };

    const rowsSeleccionadas = fixRows(row);

    Dispatch({
      type: "SET_DATOS_SELECCIONADOS",
      payload: {
        row: rowsSeleccionadas,
        data: fixdata(datos),
      },
    });
    setDatosSeleccionados(rowsSeleccionadas);
  };

  const getVisibleRows = useCallback(() => {
    if (opcionesListado.paginar_backend === "s") {
      return datosStore;
    }

    const start = currentPage * currentPageSize;
    const end = start + currentPageSize;
    return datosStore.slice(start, end);
  }, [
    currentPage,
    currentPageSize,
    datosStore,
    opcionesListado.paginar_backend,
  ]);

  const buildAutoSelectedRows = useCallback(
    (rows) => {
      const seleccionData = opcionesListado.listado_seleccion_data;

      if (!seleccionData || seleccionData.trim() === "") {
        return rows;
      }

      return rows
        .map((row) => {
          const selectedRow = {};

          seleccionData.split("|").forEach((idA) => {
            const cabecera = cabeceras.find((cab) => cab.id_a === idA);

            if (Object.prototype.hasOwnProperty.call(row, idA)) {
              selectedRow[idA] = row[idA];
              if (cabecera?.clave_envio) {
                selectedRow[cabecera.clave_envio.trim()] = row[idA];
              }
            }
          });

          return selectedRow;
        })
        .filter((row) => Object.keys(row).length > 0);
    },
    [cabeceras, opcionesListado.listado_seleccion_data]
  );

  const updateVisibleCheckboxColumn = useCallback(
    (cab, checked) => {
      const visibleRows = getVisibleRows();
      if (!visibleRows.length) return;

      const usarValores = cab.usar_valores?.split(",") ?? [];
      const checkedValue = usarValores[0]?.toString().trim() ?? "s";
      const uncheckedValue = usarValores[1]?.toString().trim() ?? "n";
      const nextValue = checked ? checkedValue : uncheckedValue;
      const key = cab.campo_alias ? cab.campo_alias : cab.id_a;
      const visibleRowsByKey = new Map(
        visibleRows.map((row) => [row._key ?? row.tableData?.id, row])
      );

      const nuevosDatos = datosStore.map((row, index) => {
        const rowKey = row._key ?? index;
        if (!visibleRowsByKey.has(rowKey)) {
          return row;
        }

        return {
          ...row,
          [key]: nextValue,
        };
      });

      Dispatch({
        type: "SET_DATOS",
        payload: nuevosDatos,
      });
      setDatosStore(nuevosDatos);
    },
    [Dispatch, datosStore, getVisibleRows, setDatosStore]
  );

  const renderHeaderCheckbox = useCallback(
    (cab) => {
      if (cab.componente !== "checkbox") return null;
      if (cab.showSelectAllCheckbox !== "s") return null;
      if (cab.update_campo) return null;

      const visibleRows = getVisibleRows();
      const usarValores = cab.usar_valores?.split(",") ?? [];
      const checkedValue = usarValores[0]?.toString().trim() ?? "s";
      const key = cab.campo_alias ? cab.campo_alias : cab.id_a;
      const isCheckedValue = (currentValue) => {
        if (currentValue === null || currentValue === undefined) return false;
        return currentValue?.toString().trim() === checkedValue;
      };
      const allChecked =
        visibleRows.length > 0 &&
        visibleRows.every((row) => isCheckedValue(row[key]));
      const someChecked = visibleRows.some((row) => isCheckedValue(row[key]));

      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "0.35rem",
          }}
        >
          <span>{cab.nombre_alias ? datos[0]?.[cab.nombre_alias] : cab.nombre}</span>
          <span
            onClick={(event) => {
              event.stopPropagation();
            }}
            onMouseDown={(event) => {
              event.stopPropagation();
            }}
          >
            <MuiCheckbox
              checked={allChecked}
              indeterminate={!allChecked && someChecked}
              onChange={(event) =>
                updateVisibleCheckboxColumn(cab, event.target.checked)
              }
              size="small"
            />
          </span>
        </div>
      );
    },
    [datos, getVisibleRows, updateVisibleCheckboxColumn]
  );

  useEffect(() => {
    const autoSeleccionPorPagina =
      opcionesListado.listado_auto_seleccion === "s" &&
      opcionesListado.listado_auto_seleccion_por_pagina === "s";

    if (!autoSeleccionPorPagina) {
      return;
    }

    const rowsSeleccionadas = buildAutoSelectedRows(getVisibleRows());

    Dispatch({
      type: "SOLO_SET_DATOS_SELECCIONADOS",
      payload: rowsSeleccionadas,
    });
    setDatosSeleccionados(rowsSeleccionadas);
  }, [
    Dispatch,
    buildAutoSelectedRows,
    currentPage,
    currentPageSize,
    datosStore,
    getVisibleRows,
    opcionesListado.listado_auto_seleccion,
    opcionesListado.listado_auto_seleccion_por_pagina,
    setDatosSeleccionados,
  ]);

  return (
    <Wrapper opcionesListado={opcionesListado} gridColumn={gridColumn}>
      <HeaderConf
        opciones={opcionesListado}
        className={"configuracion_pantalla_titulo_secundario"}
      />

      <CardBody
        style={{ padding: 0, minHeight: opcionesListado.height }}
        className="listado_card_body"
      >
        <Filtros opciones={opcionesListado} setMapa={setMapa} data={datos} />
        {loading || opcionesListado === undefined ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "80%",
              position: "fixed",
              zIndex: 500,
            }}
          >
            <OrixiaSpinner text={"Cargando..."} />
          </div>
        ) : (
          <></>
        )}
        <MaterialTable
          tableRef={tableRef}
          isLoading={loading || opcionesListado === undefined}
          hideSortIcon={false}
          style={{ display: mapa ? "none" : "inherit" }}
          icons={tableIcons}
          renderSummaryRow={
            renderSummaryRow
              ? (j) => {
                const { column } = j;
                if (column.totalizar === "s") {
                  return {
                    value: tots[column.field].toFixed(2),
                    style: {
                      textAlign: column.cellStyle.textAlign ?? "right",
                      borderTop: "double",
                      fontSize: "0.8rem",
                      padding: "2px 6px",
                    },
                  };
                }
                return undefined;
              }
              : undefined
          }
          localization={{
            header: {
              //actions: "Acciones",
            },
            body: {
              emptyDataSourceMessage: mensajeSinDatos,
            },
            pagination: {
              labelDisplayedRows: labelDisplayedRows,
              labelRowsSelect: "Filas",
              labelRowsPerPage: "Productos x pág",
              firstAriaLabel: "Primera",
              lastAriaLabel: "Ultima",
              firstTooltip: "Primera página",
              lastTooltip: "Ultima página",
              previousAriaLabel: "Página anterior",
              previousTooltip: "Página anterior",
              nextAriaLabel: "Próxima pagina",
              nextTooltip: "Próxima pagina",
            },
            toolbar: {
              searchTooltip: "Buscar",
              searchPlaceholder: "Buscar",
            },
          }}
          columns={useMemo(
            opcionesListado.consultaEjecutada === "s"
              ? () =>
                cabeceras
                  .sort((a, b) => a.orden - b.orden)
                  .filter((cab) => cab.componente !== "null")
                  .filter((cab) => cab.componente !== "mapa")
                  .map((cab, i) => {
                    return {
                      title: renderHeaderCheckbox(cab) ?? (cab.nombre_alias
                        ? datos[0][cab.nombre_alias]
                        : cab.nombre),
                      field: cab.campo_alias ?? cab.id_a,
                      width: undefined,
                      totalizar: cab.totalizar ?? undefined,
                      // customFilterAndSearch: (term, rowData, column) =>console.log("custom filter and search",term,rowData,column),
                      cellStyle: {
                        textAlign: cab.align ?? "center",
                        // width: cab.width ?? "10%",
                        padding: padding,
                        fontSize: "0.8rem",
                        lineHeight: 1,
                        width: undefined,
                      },
                      id: cab.id_a,
                      headerStyle: {
                        textAlign: "left",
                        fontSize: "0.8rem",
                        padding: padding,
                        height: "0.8em",
                        width: undefined,
                      },
                      children: cab.sc_hijos,
                      render: (data) => {
                        const totalStyle = {
                          ...cab,
                          borderTop: "double",
                        };
                        const id_elemento =
                          cab.id_a + "_" + data.tableData.id;

                        return (
                          <SwitchColumnas
                            id={data._key}
                            data={data}
                            cab={data.TOTALES === 1 ? totalStyle : cab}
                            indiceData={data.tableData.id}
                            // Context={ListadoContext}
                            id_elemento={id_elemento}
                            key={data._key}
                          />
                        );
                      },
                      mostrar: cab.mostrar,
                      componente: cab.componente,
                    };
                  })
                  .filter((cab) => cab.componente !== "hidden")
                  .filter((cab) => cab.mostrar !== "n")
              : () => [],
            [cabeceras, currentPage, datos, renderHeaderCheckbox],
          )}
          data={datos}
          actions={[]}
          options={{
            filtering: false,
            actionsColumnIndex: -1,
            showTitle: false,
            toolbar: opcionesListado.search === "s" && datos.length !== 0,
            pageSize: currentPageSize,
            pageSizeOptions: pageOptions,
            headerStyle: {
              textAlign: "left",
              fontWeight: "bold",
              height: "57px",
            },
            search: opcionesListado.search === "s",
            searchFieldStyle: { top: "3px" },
            // tableLayout: "fixed",
            selection:
              datos.length > 0 &&
              opcionesListado.listado_seleccion &&
              opcionesListado.listado_seleccion === "s",
            showSelectAllCheckbox:
              datos.length > 0 &&
              opcionesListado.showSelectAllCheckbox &&
              opcionesListado.showSelectAllCheckbox === "s",
            showTextRowsSelected: opcionesListado.showTextRowsSelected,
            rowStyle: (r) => {
              if (opcionesListado.rowStyle) {
                return r.tableData.id === selected
                  ? {
                    background: "#bde0b1",
                    color: "black",
                    fontWeight: 600,
                  }
                  : {};
              }
              return {};
            },
          }}
          onSelectionChange={(row, l) => {
            if (!l && row.length !== 0) {
              row = row.filter((r) => {
                const c = tableRef.current.dataManager.pagedData.some(
                  (pd) => pd.tableData.id === r.tableData.id,
                );
                return c;
              });
              row = updateSelectedArray(selected, row);
            }
            setSelected(row);
            dispatchSeleccion(row);

            if (subirDatosSeleccionados) {
              // console.log("vivo por aqui")
              subirDatosSeleccionados(row, opcionesListado);
            }

            // funcion select
            if (opcionesListado.listado_seleccion_habilitado) {
              row = row.filter(
                (r) =>
                  r[opcionesListado.id_a + "_listado_seleccion_habilitado"] ===
                  1,
              );
            }

            if (!!opcionesListado.onSelectionChange) {
              opcionesListado.onSelectionChange(row);
            }
            return row;
          }}
          onRowClick={(e, row) => {
            if (opcionesListado.onRowClick) {
              setSelected(row.tableData.id);
              opcionesListado.onRowClick(e, row, datos);
              dispatchSeleccion(row);
            }
          }}
          onRowDoubleClick={(e, row) => {
            if (opcionesListado.onRowDoubleClick) {
              setSelected(row.tableData.id);
              opcionesListado.onRowDoubleClick(e, row, datos);
            }
          }}
          components={{
            OverlayLoading: () => {
              return (
                <div
                  style={{
                    display: "table",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgb(255, 255, 255)",
                    opacity: "0.7",
                  }}
                >
                  <div
                    style={{
                      display: "table-cell",
                      width: "100%",
                      height: "100%",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  ></div>
                </div>
              );
            },
            Body: (props) => {
              if (opcionesListado.consultaEjecutada === "n") return <></>;
              return <MTableBody {...props} />;
            },
            Row: (props) => {
              const habilitado = opcionesListado.listado_seleccion_habilitado
                ? props.data[
                opcionesListado.id_a + `_listado_seleccion_habilitado`
                ] === 1
                : true;

              return (
                // <MTableBodyRow id={props.data._id} {...props} enableRowSelection={false}                    />
                // <OrixiaRow {...props} enableRowSelection={habilitado} />
                <MemoizedOrixiaRow
                  {...props}
                  id={props.data._key}
                  enableRowSelection={habilitado}
                />
              );
            },
            Pagination: (props) => {
              //  if (data.length === 0 || !data) return <></>;
              if (opcionesListado.paginacion === "n") return <></>;
              if (opcionesListado.consultaEjecutada === "n") return <></>;
              if (!datos || datos.length === 0) return <></>;

              if (opcionesListado.paginar_backend === "s") {
                const { paginacion_backend } = opcionesListado;
                return (
                  <TablePagination
                    {...props}
                    className={
                      opcionesListado.paginacion === "n" ? "d-none" : ""
                    }
                    localization={{
                      pagination: { labelDisplayedRows: labelDisplayedRows },
                    }}
                    page={Number(paginacion_backend.currentPage)}
                    rowsPerPage={currentPageSize}
                    count={
                      paginacion_backend.hasTotal
                        ? Number(paginacion_backend.total) +
                        Number(paginacion_backend.perPage)
                        : -1
                    }
                    onPageChange={(event, page) => {
                      setCurrentPage(page);
                      cambiarPagina(page, currentPageSize);
                    }}
                    onRowsPerPageChange={(e, b) => {
                      setCurrentPageSize(e.target.value);
                      setCurrentPage(0);
                      if (e.target.value > paginacion_backend.perPage) {
                        cambiarPagina(
                          paginacion_backend.currentPage,
                          e.target.value,
                        );
                      }

                      return e.target.value;
                    }}
                    labelRowsPerPage="Filas:"
                    SelectProps={{
                      native: false,
                      MenuProps: {
                        PaperProps: {
                          style: {
                            padding: "8px 0",
                          },
                        },
                      },
                    }}
                    labelDisplayedRows={({ page, count }) => {
                      const totalPages = Math.ceil(count / currentPageSize);
                      return `Pág. ${page + 1} de ${totalPages}`;
                    }}
                    component="div"
                  />
                );
              }
              const classes = `${opcionesListado.paginacion === "n" ? "d-none" : ""
                } item-count-display`;
              return (
                <TablePagination
                  className={classes}
                  {...props}
                  labelRowsPerPage="Filas:"
                  SelectProps={{
                    native: false,
                    MenuProps: {
                      PaperProps: {
                        style: {
                          padding: "8px 0",
                        },
                      },
                    },
                  }}
                  onPageChange={(event, page) => {
                    props.onPageChange(event, page);
                    setCurrentPage(page);
                    cambiarPagina(page, currentPageSize);
                  }}
                  labelDisplayedRows={({ page, count }) => {
                    const totalPages = Math.ceil(count / currentPageSize);
                    return `Pág. ${page + 1} de ${totalPages}`;
                  }}
                  component="div"
                />
              );
            },
          }}
        // style={{ minWidth: "1300px", overflowX: "auto" }}
        />

        {opcionesListado.usar_mapa === "s" && mapaCab ? (
          <Mapa
            display={mapa ? "inherit" : "none"}
            data={datos}
            cab={mapaCab}
          />
        ) : (
          <></>
        )}

        <Botonera
          handleSubmit={() => null}
          handleCancelar={handleCancelar}
          loading={loading || opcionesListado.consultaEjecutada !== "s"}
          buscar={0}
          cancelar={0}
          acciones={listadoBotonesInferiores}
          className={"container_buttons_inferiores"}
          context={ListadoContext}
          submit={opcionesListado.submit_button}
          submit_handleSubmit={opcionesListado.submit_button_handleSubmit}
          submit_texto={opcionesListado.submit_texto}
          data={datos[0]}
          hayDatos={datos.length > 0}
        />
      </CardBody>
    </Wrapper>
  );
};

const Wrapper = ({ children, gridColumn, opcionesListado }) => {
  return (
    <Paper
      elevation={3} // Controla la intensidad de la sombra (0 a 24)
      style={{ ...gridColumn, borderRadius: "8px" }}
      className={`listado_card animated fadeIn ${opcionesListado.className}`}
    >
      <Card
        id={opcionesListado.id_a}
        style={{ border: "none", marginBottom: 0, background: "transparent" }}
      >
        {children}
      </Card>
    </Paper>
  );
};

export default Listado;
